<template>
        <!-- 账单明细列表 -->
        <el-table :key="0" :data="list" stripe v-loading="loading" :element-loading-text="loadingText" border
                    fit highlight-current-row class="w-100">

            <!-- 保单号 -->
            <el-table-column align="left" label="保/批单号" >
            <template slot-scope="scope">
                <!-- <span v-if="$perm(['company.view_insurance_company'])" class="text-link"
                    @click="handleUpdate(scope.row.id)">{{scope.row.policy_number}}</span> -->
                <span>{{scope.row.policy_number}}</span>
            </template>
            </el-table-column>

            <!-- 投保人 -->
            <el-table-column align="left" label="投保人" >
            <template slot-scope="scope">
                <span>{{ scope.row.policy_holder }}</span>
            </template>
            </el-table-column>

            <!-- 缴费期数 -->
            <el-table-column align="left" label="缴费期数" >
            <template slot-scope="scope">
                <span>{{ scope.row.payment_period | parseTime('{y}年{m}月{d}日') }}</span>
            </template>
            </el-table-column>

            <!-- 实收保费 -->
            <el-table-column align="left" label="实收保费" >
            <template slot-scope="scope">
                <span>{{ scope.row.tex_free_premium | parsecurrency }}</span>
            </template>
            </el-table-column>

            <!-- 实收日期 -->
            <el-table-column align="left" label="实收保费日期" >
            <template slot-scope="scope">
                <span>{{ scope.row.collected_date | parseTime('{y}年{m}月{d}日') }}</span>
            </template>
            </el-table-column>

            <!-- 手续费比例% -->
            <el-table-column align="left" label="手续费比例%" >
            <template slot-scope="scope">
                <span>{{ scope.row.commission_rate}}</span>
            </template>
            </el-table-column>

            <!-- 应付手续费 -->
            <el-table-column align="left" label="应付手续费" >
            <template slot-scope="scope">
                <span>{{ scope.row.tax_fee_commission | parsecurrency }}</span>
            </template>
            </el-table-column>

            <!-- 本结算单手续费 -->
            <el-table-column align="left" label="本结算单手续费" >
            <template slot-scope="scope">
                <span>{{ scope.row.statement_tax_fee_commission | parsecurrency }}</span>
            </template>
            </el-table-column>

            <!-- 含税保费 -->
            <el-table-column align="left" label="含税保费" >
            <template slot-scope="scope">
                <span>{{ scope.row.premium | parsecurrency }}</span>
            </template>
            </el-table-column>

            <!-- 含税应付手续费 -->
            <el-table-column align="left" label="含税应付手续费" >
            <template slot-scope="scope">
                <span>{{ scope.row.commission | parsecurrency }}</span>
            </template>
            </el-table-column>
        </el-table>
</template>

<script>
import { formatCurrency } from '@/utils/misc'
export default {
    name: 'billing-record-list-da-di',
    components: {
    },
    filters: {
      parsecurrency: function(value){
        let v = parseFloat(value).toFixed(4)
        return formatCurrency(v, 2)
      },
    },
    props: [
        'list',
        'loading',
        'loadingText'
    ]
}
</script>
<style lang="scss">

</style>
